import { Controller } from '@hotwired/stimulus'

export default class BonusCodeController extends Controller {
  static targets = ['input', 'inputContainer', 'bonusCodeButton'];

  connect() {
    if (this.inputTarget.value) {
      this.inputContainerTarget.classList.remove('d-none');
      this.bonusCodeButtonTarget.classList.add('d-none');
    }
  }

  addBonusCode() {
    this.inputContainerTarget.classList.remove('d-none');
    this.inputTarget.focus();
    this.bonusCodeButtonTarget.classList.add('d-none');
  }

  removeBonusCode() {
    this.inputContainerTarget.classList.add('d-none');
    this.inputTarget.value = '';
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.bonusCodeButtonTarget.classList.remove('d-none');
  }
}
